// Components
import SvgIcon from "@mui/material/SvgIcon";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";

const CommonCoordination = "2.5";
const CheckboxSize = "18";
const CheckboxBorderRadius = "3px";

type CustomIndeterminateIconType = {
  checkedFill: string;
  checkedStroke: string;
};

const CustomIndeterminateIcon = ({
  checkedFill,
  checkedStroke,
}: CustomIndeterminateIconType) => (
  <SvgIcon>
    <rect
      x={CommonCoordination}
      y={CommonCoordination}
      width={CheckboxSize}
      height={CheckboxSize}
      fill={checkedFill}
      strokeWidth="1.5"
      stroke={checkedFill}
      rx={CheckboxBorderRadius}
      ry={CheckboxBorderRadius}
    />
    <path
      d="M7.5 12l8 0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      stroke={checkedStroke}
      fill="none"
    />
  </SvgIcon>
);

type CustomUncheckedIconType = {
  uncheckedFill: string;
  uncheckedStroke: string;
};

const CustomUncheckedIcon = ({
  uncheckedFill,
  uncheckedStroke,
}: CustomUncheckedIconType) => (
  <SvgIcon>
    <rect
      x={CommonCoordination}
      y={CommonCoordination}
      width={CheckboxSize}
      height={CheckboxSize}
      fill={uncheckedFill}
      strokeWidth="2"
      stroke={uncheckedStroke}
      rx={CheckboxBorderRadius}
      ry={CheckboxBorderRadius}
    />
  </SvgIcon>
);

type CustomCheckedIconType = {
  checkedFill: string;
  checkedStroke: string;
};

const CustomCheckedIcon = ({
  checkedFill,
  checkedStroke,
}: CustomCheckedIconType) => (
  <SvgIcon>
    <rect
      x={CommonCoordination}
      y={CommonCoordination}
      width={CheckboxSize}
      height={CheckboxSize}
      fill={checkedFill}
      strokeWidth="1.5"
      stroke={checkedFill}
      rx={CheckboxBorderRadius}
      ry={CheckboxBorderRadius}
    />
    <path
      d="M6 12l3 3 7-7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      stroke={checkedStroke}
      fill="none"
    />
  </SvgIcon>
);

type CustomCheckboxType = {
  checked: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  indeterminate?: boolean;
  checkedFill?: string;
  checkedStroke?: string;
  uncheckedFill?: string;
  uncheckedStroke?: string;
  sx?: CheckboxProps["sx"];
  id?: string;
};

/**
 * Customized Checkbox
 */
const CustomCheckbox = ({
  checked,
  onClick,
  disabled = false,
  indeterminate = false,
  checkedFill = "#000",
  checkedStroke = "#FFF",
  uncheckedFill = "#FFF",
  uncheckedStroke = "#000",
  sx = {},
  id,
}: CustomCheckboxType) => {
  return (
    <Checkbox
      id={id}
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
      onClick={onClick}
      sx={{
        padding: 0,
        ...sx,
      }}
      icon={
        <CustomUncheckedIcon
          uncheckedFill={uncheckedFill}
          uncheckedStroke={uncheckedStroke}
        />
      }
      checkedIcon={
        <CustomCheckedIcon
          checkedFill={checkedFill}
          checkedStroke={checkedStroke}
        />
      }
      indeterminateIcon={
        <CustomIndeterminateIcon
          checkedFill={checkedFill}
          checkedStroke={checkedStroke}
        />
      }
    />
  );
};

export default CustomCheckbox;
